
import React, { FC, useEffect } from 'react';
import { Input } from 'antd';
import { getAutoCode } from '@/common/asset-apis/assetModel';
import { useUpdateEffect, useDebounceEffect } from 'ahooks';
import { jsonataFactory } from '@/utils';
import memo from '../memo';

interface AssetTextAutoFillValueProps {
  value?: any;
  onChange?: any;
  SystemAPI?: any;
  disabled?: boolean;
  allowClear?: boolean;
  /** 编码生成规则 */
  generationRule?: string;
  /** 完全的全量数据 */
  values?: any;
}

/** 临时替换占位符 */
const SerialNumberPlaceholder = 'SERIAL_NUMBER';

export const AssetTextAutoSerialNumber: FC<AssetTextAutoFillValueProps> = ({
  value,
  onChange,
  SystemAPI,
  disabled,
  allowClear,
  generationRule,
  values,
}) => {
  // 匹配生成规则中是否使用 $serialNumber()
  const matchSerialNumber = generationRule?.match(/\$serialNumber\(.*?\)/)?.[0];
  let prefix = '';
  const getValue = () => {
    // 如果存在 $serialNumber()，则对serialNumber进行转化，调用接口生成流水号
    if (matchSerialNumber) {
      // eslint-disable-next-line no-new-func
      const func = new Function('$serialNumber', `return ${matchSerialNumber}`);
      const params = func((timestampType: string, length: number) => ({ timestampType, length }));
      getAutoCode(SystemAPI, {
        prefix: prefix.replace(SerialNumberPlaceholder, ''),
        timestamp_type: params.timestampType,
        len_random_number: params.length,
      }, 'self_defined_serial_number').then((res: any) => {
        const [e, data] = res;
        onChange(data?.data?.data);
      });
    } else {
      // 否则直接将前缀作为值上报
      setTimeout(() => {
        onChange(prefix);
      }, 500);
    }
  };

  // 前缀生成，如果包含 $serialNumber()，则先临时替换掉，然后使用jsonata生成动态数据
  try {
    prefix = jsonataFactory(
      matchSerialNumber ?
        generationRule.replace(matchSerialNumber, `'${SerialNumberPlaceholder}'`)
        : (generationRule || ''),
    ).evaluate(values);
  } catch (e) {
    prefix = generationRule || '';
  }

  // 第一次加载，判定是否有值
  useDebounceEffect(() => {
    if (prefix && !value) {
      getValue();
    }
  }, [prefix, value], { wait: 500 });

  useUpdateEffect(() => {
    getValue();
  }, [prefix]);

  return (
    <Input value={value} disabled={disabled} />
  );
};

export default React.memo(AssetTextAutoSerialNumber);
